import { transparentize } from 'polished';
import React from 'react';

import { DsrIconProps, Svg } from './wrappers';

const Icon = ({
  primaryColor,
  selectedColor,
  selected,
  ...svgProps
}: DsrIconProps): JSX.Element => (
  <Svg viewBox="0 0 24 24" version="1.1" {...svgProps}>
    <title>DSR/icon/access:default</title>
    <desc>Created with Sketch.</desc>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M 3 7 L 21 7 L 21 19 L 3 19 Z M 3 7 "
        fill={selected ? selectedColor : transparentize(0.7, primaryColor)}
        fillRule="nonzero"
      />
      <path
        // eslint-disable-next-line max-len
        d="M 20 6 L 12 6 L 10 4 L 4 4 C 2.898438 4 2 4.898438 2 6 L 2 18 C 2 19.101562 2.898438 20 4 20 L 20 20 C 21.101562 20 22 19.101562 22 18 L 22 8 C 22 6.898438 21.101562 6 20 6 Z M 20 18 L 4 18 L 4 8 L 20 8 Z M 20 18 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
      <path
        d="M 11 10 L 13 10 L 13 16 L 11 16 Z M 11 10 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
      <path
        d="M 16 13 L 12 17 L 8 13 Z M 16 13 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
    </g>
  </Svg>
);

export default Icon;
